import React from 'react';
import {
  Backdrop,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

interface SpinnerProps {
  open: boolean;
  text?: string;
}
export function Spinner({ open, text }: SpinnerProps) {
  const theme = useTheme();
  return (
    <Backdrop
      sx={{
        color: theme.palette.primary.main,
        zIndex: theme.zIndex.drawer + 1,
      }}
      open={open}
    >
      <Stack direction="column" spacing={2} sx={{ alignItems: 'center' }}>
        <CircularProgress color="inherit" />
        {text && <Typography variant="h6">{text}</Typography>}
      </Stack>
    </Backdrop>
  );
}
